import { render, staticRenderFns } from "./Iinitiated.vue?vue&type=template&id=6ef5a1fa&scoped=true&"
import script from "./Iinitiated.vue?vue&type=script&lang=js&"
export * from "./Iinitiated.vue?vue&type=script&lang=js&"
import style0 from "./Iinitiated.vue?vue&type=style&index=0&id=6ef5a1fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5a1fa",
  null
  
)

export default component.exports